var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonvernIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.14,
    height: 19.098,
    viewBox: "0 0 16.14 19.098",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "personvern_icon",
    "data-name": "personvern icon",
    transform: "translate(0.75 0.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4208",
    "data-name": "Group 4208"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1885",
    "data-name": "Path 1885",
    d: "M11168.552,6249.934v8.986a5.562,5.562,0,0,1-1.909,4.6l-5.409,4.007-5.414-4.007a5.561,5.561,0,0,1-1.907-4.6v-8.986h14.64Z",
    transform: "translate(-11153.912 -6249.934)",
    fill: "#d9e4e4",
    stroke: "#00615c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1886",
    "data-name": "Path 1886",
    d: "M11158.8,6257.992l2.232,2.022,4.265-3.91",
    transform: "translate(-11154.512 -6250.687)",
    fill: "#d9e4e4",
    stroke: "#00615c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonvernIcon);
export default __webpack_public_path__ + "static/media/personvern-icon.39d051446fa439801558021b87896e22.svg";
export { ForwardRef as ReactComponent };